import { render, staticRenderFns } from "./BattleAcademiaMatchCloseView.vue?vue&type=template&id=6794ca88&"
import script from "./BattleAcademiaMatchCloseView.vue?vue&type=script&lang=js&"
export * from "./BattleAcademiaMatchCloseView.vue?vue&type=script&lang=js&"
import style0 from "./BattleAcademiaMatchCloseView.vue?vue&type=style&index=0&id=6794ca88&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports